(function ($) {
  let isMobile = false;
  let rtime;
  let timeout = false;
  const delta = 200;

  const isPageEditor = function () {
    return !!(typeof Sitecore !== 'undefined' && Sitecore.PageModes && Sitecore.PageModes.PageEditor);
  };

  const detectMobile = () => {
    // Device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      isMobile = true;
    }
  };

  const mobileSelect = () => {
    const select = $('select');

    if (select.length && isMobile) {
      select.addClass('isMobile').wrap('<span class="mobileselect" />');
    }
  };

  const makeModal = function () {
    // Dynamically add modal triggers to any link that includes the class "modal-link"
    if ($('.modal-link').length) {
      $('.modal-link').each(function () {
        const modalUrl = $(this)[0].href;
        const modalId = modalUrl.split('#').pop(); // Extract ID string after hash

        $(this).attr('data-toggle', 'modal');
        // $(this).attr('data-target', `#${modalId}`);
        $(this).attr('data-target', `${modalId}`);
      });
    }

    $('.modal-link').on('click', (e) => {
      e.preventDefault();
    });
  };

  const stackLegs = function () {
    // If in Experience Editor, wrap multiple "progress-content" sections in a container
    // so that they can be stacked

    $('.progress-content + .progress-content').each(function () {
      $(this).prev().addBack().wrapAll('<div class="stack">');
    });
  };

  const iconFix = function () {
    // Adds a span wrapper to allow svg manipulation
    $('.progress-icon svg').each(function () {
      $(this).wrap('<span></span>');
    });
  };

  const pageBackground = function () {
    // This simply controls whether an additional page background element should appear or not
    // Add any element to text for its existence. If it exists on a page, the background will
    // be hidden

    let bgExceptions = [
      '.page-error',
    ];

    $.each(bgExceptions, (index, value) => {
      if ($(value).length) {
        $('body').addClass('nobg');
      } else {
        $('body').addClass('hasbg');
      }
    });
  };

  // Select Menu - Chosen Dropdowns
  const chosenDropdowns = () => {
    if ($('select').length) {
      $('select').chosen({
        disable_search: true,
      });
    }
  };

  const videoMQ = () => {
    const video = $('.component-timeline_banner video');

    if (video.length) {
      // Replace video <source> with proper video based on screen size
      const windowWidth = $(window).width();
      const videoSrcDesktop = video.attr('srcDesktop');
      const videoSrcTablet = video.attr('srcTablet');

      if (windowWidth >= 991) {
        video.append(`<source src="${videoSrcDesktop}" type="video/mp4" >`);
      } else if (windowWidth <= 991 && windowWidth >= 768) {
        video.append(`<source src="${videoSrcTablet}" type="video/mp4" >`);
      }
    }
  };

  const experienceEditorUtilities = () => {
    if (isPageEditor()) {
      $('body').addClass('is-editor');
      $('#modalVideo').hide();
      $('body').removeClass('modal-open');
      $('#videoLoader').attr('src', '');
      $('.modal-backdrop').remove();
      $('.panel-collapse').collapse('toggle');
      stackLegs();
    }
  };

  const resetGypsyForm = () => {
    $('#gypsyReset').on('click', (e) => {
      e.preventDefault();
      document.getElementById('gypsyMoth').reset();
    });
  };

  const inputMask = () => {
    $('[data-mask=phone]').mask('999-999-9999', { placeholder: ' ', autoclear: false });
    $('[data-mask=date]').mask('99/99/9999', { placeholder: ' ' });
    $('[data-mask=accountid]').mask('99-999999999', { placeholder: ' ' });
  };

  const mobileToggle = () => {
    const toggleSwitch = $('.toggleSwitch');

    if (window.innerWidth <= 586) {
      $(toggleSwitch).parent().parent().addClass('mobile');
    }

    window.onresize = function () {
      if (window.innerWidth <= 586) {
        $(toggleSwitch).parent().parent().addClass('mobile');
      } else {
        $(toggleSwitch).parent().parent().removeClass('mobile');
      }
    };
  };

  const resizeend = function () {
    if (new Date() - rtime < delta) {
      setTimeout(resizeend, delta);
    } else {
      timeout = false;

      $('.scrtabs-tabs-fixed-container').attr('style', '');
      $('.scrtabs-tabs-movable-container').attr('style', '');
      $('.nav-tabs').scrollingTabs('refresh');
    }
  };

  const tabScroll = () => {
    if ($('.component-tabs')) {
      $('.nav-tabs:not(.noscroll)').scrollingTabs({
        bootstrapVersion: 4,
        disableScrollArrowsOnFullyScrolled: true,
        enableSwiping: false,
      }).on('ready.scrtabs', () => {
        $('.tab-content').show();
      });

      $(window).resize(() => {
        rtime = new Date();

        if (timeout === false) {
          timeout = true;
          setTimeout(resizeend, delta);
        }
      });
    }
  };

  const timeoutHandler = () => {
    $(document).ajaxComplete(() => {
      window.clearTimeout(window.inactivityTimeout);
      setSessionTimeout();
    });
  };

  const setSessionTimeout = () => {
    window.inactivityTimeout = setTimeout(() => {
      logout(`${window.globalTimeoutOptions.loginUrl}`, null);
    }, window.globalTimeoutOptions.timeout);
  };

  const initialDatePicker = () => {
    // Change initial font color after date has been selected
    const datePicker = $('.selected-date-picker');

    $(datePicker).on('change', function () {
      $(this).addClass('active');
    });
  };

  const movePayment = function () {
    const resizeend = function () {
      $('.component-account-title.payment .edit a').each(function () {
        let moveTo = $(this).parent().parent().siblings('.infobody').find('.edit');
        $(this).detach().appendTo(moveTo);
      });
    };

    $(window).on('resize load', () => {
      resizeend();
    });
  };

  const podsGaSetup = function () {
    const setupCrossDomain = function () {
      if (window.globalGaSettings.gtmId) {
        const urlParams = new URLSearchParams(window.location.search);
        const clientId = urlParams.get('clientId');
        const sessionId = urlParams.get('sessionId');
        if (clientId && sessionId) {
          dataLayer.push('config', window.globalGaSettings.gtmId, {
            'client_id': clientId,
            'session_id': sessionId
            });
        }
        else {
          console.debug("Unable to set GA client_id and session_id:", window.globalGaSettings.gtmId, clientId, sessionId);
        }
      }
    };

    setupCrossDomain();
  };

  const datePickerBlur = function () {
    $(document).on('click, scroll', function (e) {
			// Date picker "sticks" focus if scrolled on a mobile device.
			var container = $('.selected-date-picker');

			if (!container.is(e.target) && container.has(e.target).length === 0) {
				$('.selected-date-picker').blur();
			}
		});
  }

  const init = () => {
    detectMobile();
    experienceEditorUtilities();
    pageBackground();
    makeModal();
    stackLegs();
    chosenDropdowns();
    videoMQ();
    resetGypsyForm();
    inputMask();
    feather.replace();
    mobileToggle();
    mobileSelect();
    tabScroll();
    initialDatePicker();
    movePayment();
    iconFix();
    datePickerBlur();

    if (window.globalTimeoutOptions) {
      setSessionTimeout();
      timeoutHandler();
    }
    if (window.globalGaSettings) {
      podsGaSetup();
    }
  };

  $(init);
}(jQuery));



const cookies = {
	getCookie: function getCookie(cookieName) {
		const match = document.cookie.match(new RegExp(cookieName + '=([^;]+)'));
		if (match) return match[1];
	},
	setCookie: function setCookie(cookieName, cookieValue, expiresInHours) {
		let expiresString = '';
		if (expiresInHours) {
			var date = new Date();
			date.setTime(date.getTime() + (expiresInHours * 60 * 60 * 1000));
			expiresString = " expires=" + date.toUTCString();
		}
		document.cookie = cookieName + ' = ' + cookieValue + ';  path=/; ' + expiresString;
	}
};
